module.exports = __webpack_public_path__ + "img/DESIGN_04.7fc5eb29.jpg";